import { gql } from '@apollo/client';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

export type DjRequestedUsersQuery = {
  eventUsers: Array<{
    id: string;
    firstname?: string | null;
    lastname?: string | null;
    nickname?: string | null;
    studyTown?: string | null;
    studies?: string | null;
    hasRequestedDj: boolean;
    djStyle?: string | null;
    djTime?: string | null;
  }>;
};

export type DjRequestedUsersQueryVariables = {
  eventId: string;
};

export const DJ_REQUESTED_USERS = gql`
  query DjRequestedUsers($eventId: ID!) {
    eventUsers(eventId: $eventId) {
      id
      firstname
      lastname
      nickname
      studyTown
      studies
      hasRequestedDj(eventId: $eventId)
      djStyle(eventId: $eventId)
      djTime(eventId: $eventId)
    }
  }
` as DocumentNode<DjRequestedUsersQuery, DjRequestedUsersQueryVariables>;
